import moment from "moment";
import cloneDeep from 'lodash/cloneDeep';
import { recorrenciaApiParaCadastro } from '../../components/ModalCadastroFinanceiro/cadastroFinanceiroRecorrenciaUtils';
import {
  opcaoClassificacaoFiscal,
  opcaoMultaTipo,
} from '../../components/ModalCadastroFinanceiro/cadastroFinanceiroClassificacaoFiscal';
import {
  origemEdicaoFromApi,
} from '../../components/ModalCadastroFinanceiro/cadastroFinanceiroClienteUtils';
import {
  parseValorBr,
  somaPagamentosEmbarque,
  normalizarPagamentosEmbarqueDaApi,
  normalizarCompetenciaPrimeiroDia,
} from '../../components/ModalCadastroFinanceiro/cadastroFinanceiroUtils';

const parseDataFormulario = (valor, fallback = null) => {
  if (valor == null || valor === "") {
    return fallback;
  }
  const m = moment(valor, "YYYY-MM-DD", true);
  if (m.isValid()) {
    return m.toDate();
  }
  const flex = moment(valor);
  return flex.isValid() ? flex.toDate() : fallback;
};

const linhaPagamentoEmbarqueVazia = () => ({
  valor: "",
  formaPagamento: {
    label: "Selecione a forma de pagamento!",
    value: "",
    pag_credito: null,
    pag_idtipo: null,
  },
  banco: { label: "Selecione o banco!", value: 0 },
  fontePagamento: { label: "Selecione a fonte de pagamento!", value: "" },
  parcela: { label: "1X", value: 1 },
  dataPagamento: new Date(),
  comprovantesArquivos: [],
});

/** Primeiro e último dia do mês corrente + vista padrão (navegação tipo agenda). */
const datasFiltroMesCorrente = () => {
  const a = new Date();
  return {
    filtroDataDe: new Date(a.getFullYear(), a.getMonth(), 1),
    filtroDataAte: new Date(a.getFullYear(), a.getMonth() + 1, 0),
    filtroPeriodoVista: 'mes',
  };
};

const INITIAL_STATE = {
  contaPagar: {},
  contasPagar: { data: [] },
  cadastro: {
    quantidadeLancamento: 1,
    nome: '',
    descricao: '',
    competencia: new Date(),
    vencimento: new Date(),
    ultimoPagamento: null,
    dataNf: null,
    pagamento: {
      label: "",
      value: 0,
    },
    parcela: null,
    recorrente: false,
    repetir: false,
    tipoFrequenciaRecorrencia: 'MENSAL',
    periodicidade: { value: 'MENSAL', label: 'Todo mês (mensal)' },
    dataDiaVencimentoRecorrencia: null,
    diaVencimentoRecorrencia: { value: 'DATA_VENCIMENTO', label: 'Dia de vencimento' },
    terminoRecorrencia: { value: 'POR_OCORRENCIAS', label: 'Por número de ocorrências' },
    frequencia: { value: 'MENSAL', label: 'Mensalmente' },
    quantidade: 12,
    dataLancamentoRecorrencia: null,
    repetirAnualmente: { value: 'NAO', label: 'Não — repetir todo mês neste dia' },
    diasSemanaRecorrencia: [],
    diasMesRecorrencia: [],
    dataTerminoRecorrencia: null,
    classificacaoFiscal: null,
    tipoDespesa: 'VARIAVEL',
    multaTipo: opcaoMultaTipo('FIXO'),
    tipoOrigem: 'CLIENTE',
    cliente: null,
    clienteTexto: null,
    origemRazaoSocial: '',
    origemNomeFantasia: '',
    origemEndereco: '',
    origemTexto: '',
    origemCnpj: '',
    valor: 0,
    desconto: 0,
    acrescimo: 0,
    valorPago: 0,
    saldo: 0,
    multa: 0,
    total: 0,
    categoria_id: null,
    pagamentosEmbarque: [linhaPagamentoEmbarqueVazia()],
  },
  dadosFiltro: {
    id: "",
    origem: "",
    nome: "",
    categoria: "",
    subCategoria: "",
    status: [],
    tipoConta: "",
    segmento: "",
    clear: false,
    ...datasFiltroMesCorrente(),
  },
  categoriaCadastrar: {},
  categorias: [],
  subCategoriaCadastrar: {},
  subCategorias: [],
  pagination: null,
  totalValor: 0,
  totaisPorCategoria: [],
  totaisPendentePago: { total_pendente: 0, total_pago: 0, total_vencido: 0 },
  resumoVencimentos: { por_dia: [], maiores_origens: [] },
  acao: "cadastrar",
  recorrente: false,
  cifrao: "R$",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CONTAS_PAGAR_LIMPAR":
      return { ...state, contaPagar: { total: 0 }, cadastro: {} };
    case "CONTA_EDITAR_FETCH":
      return { ...state, cadastro: action.payload };
    case "CONTAS_PAGINATION":
      return { ...state, pagination: action.payload };
    case "CONTAS_PAGAR_TOTAIS_CATEGORIA":
      return {
        ...state,
        totaisPorCategoria: Array.isArray(action.payload) ? action.payload : [],
      };
    case "CONTAS_PAGAR_RESUMO_VENCIMENTOS": {
      const r = action.payload;
      return {
        ...state,
        resumoVencimentos: {
          por_dia: Array.isArray(r?.por_dia) ? r.por_dia : [],
          maiores_origens: Array.isArray(r?.maiores_origens) ? r.maiores_origens : [],
        },
      };
    }
    case "CONTAS_PAGAR_TOTAIS_PENDENTE_PAGO": {
      const p = action.payload;
      return {
        ...state,
        totaisPendentePago: {
          total_pendente: Number(p?.total_pendente) || 0,
          total_pago: Number(p?.total_pago) || 0,
          total_vencido: Number(p?.total_vencido) || 0,
          qtd_pendente: Number(p?.qtd_pendente) || 0,
          qtd_pago: Number(p?.qtd_pago) || 0,
          qtd_vencido: Number(p?.qtd_vencido) || 0,
        },
      };
    }
    case "CONTAS_PAGAR_FETCH": {
      return { ...state, contasPagar: action.payload };
    }
    case "CONTA_PAGAR_FETCH": {
      if (action.payload == null) {
        return { ...state, contaPagar: {} };
      }
      return { ...state, contasPagar: action.payload };
    }
    case "CONTA_PAGAR_SET_VISUALIZAR":
      return {
        ...state,
        contaPagar:
          action.payload != null && typeof action.payload === "object"
            ? action.payload
            : {},
      };
    case "CONTA_PAGAR_EDITAR_FETCH": {
      if (!action.payload || typeof action.payload !== "object") {
        return state;
      }

      let cadastroCopy = { ...state.cadastro };
      let copyCifrao = state.cifrao;

      const multaTipoOpt = opcaoMultaTipo(action.payload.multa_tipo);

      if (multaTipoOpt.value === "FIXO") {
        copyCifrao = "R$";
      } else {
        copyCifrao = "%";
      }

      cadastroCopy = {
        nome: action.payload.nome_conta,
        quantidadeLancamento:
          action.payload.quantidade_lancamento != null
            ? Number(action.payload.quantidade_lancamento)
            : 1,
        categoria: {
          value: action.payload?.id_categoria,
          label: action.payload?.nome_categoria,
        },
        categoria_id:
          action.payload?.id_categoria != null && action.payload?.id_categoria !== ""
            ? Number(action.payload.id_categoria)
            : null,
        valor: action.payload.valor_conta,
        descricao: action.payload.descricao,
        titulo: action.payload.titulo,
        ...origemEdicaoFromApi(action.payload),
        // pagamento: { value: action.payload?.pagamento?.pag_id, label: action.payload?.pagamento?.pag_nome },
        documento: action.payload.documento,
        competencia: normalizarCompetenciaPrimeiroDia(
          parseDataFormulario(
            action.payload.data_competencia ?? action.payload.competencia,
            state.cadastro?.competencia ?? new Date()
          )
        ),
        parcela: action.payload?.parcela
          ? {
              value: action.payload.parcela.par_id,
              label: action.payload.parcela.par_nome,
            }
          : state.cadastro?.parcela ?? null,
        boleto: action.payload.boleto,
        ultimoPagamento: parseDataFormulario(action.payload.data_ultimo_pagamento, null),
        vencimento: parseDataFormulario(
          action.payload.data_vencimento,
          state.cadastro?.vencimento ?? new Date()
        ),
        valorPago: action.payload.valor_pago,
        saldo: action.payload.saldo,
        desconto:
          action.payload.desconto != null && action.payload.desconto !== ''
            ? action.payload.desconto
            : 0,
        acrescimo:
          action.payload.acrescimo != null && action.payload.acrescimo !== ''
            ? action.payload.acrescimo
            : 0,
        multa: action.payload.multa ?? 0,
        multaTipo: multaTipoOpt,
        classificacaoFiscal: opcaoClassificacaoFiscal(action.payload.classificacao_fiscal),
        tipoDespesa: ['FIXA', 'VARIAVEL'].includes(action.payload.tipo_despesa)
          ? action.payload.tipo_despesa
          : 'VARIAVEL',
        juros: action.payload.juros,
        numeroNf: action.payload.numero_nf,
        dataNf: parseDataFormulario(action.payload.data_nf, null),
        id_pagamento: action.payload.id_pagamento,
        conta_id: action.payload.conta_id,
        status:
          action.payload.status_calculado ??
          action.payload.status ??
          'PENDENTE',
        data_vencimento_original:
          action.payload.data_vencimento_original ?? action.payload.data_vencimento,
        projecao: !!action.payload.projecao,
        somentePagamentos: !!action.payload.somente_pagamentos,
        acertoId: action.payload.acerto_id ?? null,
        pagamentosEmbarque: normalizarPagamentosEmbarqueDaApi(
          action.payload.pagamentosEmbarque,
          linhaPagamentoEmbarqueVazia
        ),
        ...recorrenciaApiParaCadastro(action.payload.recorrencia),
      };


      let saldo = 0;
      let multa = 0;
      let tipo = null;
      const jurosNum = Number(cadastroCopy.juros);
      const totalOr = Number(cadastroCopy.valor);
      const valorPago = Number(cadastroCopy.valorPago);
      const hoje = new Date();

      saldo = Number(cadastroCopy.saldo);
      multa = Number(cadastroCopy.multa);
      tipo = cadastroCopy.multaTipo?.value;

      let totalCalc = totalOr;


      const vencimentoMomentPagar = moment(cadastroCopy.vencimento);
      if (
        vencimentoMomentPagar.isValid() &&
        moment(hoje).isAfter(vencimentoMomentPagar) &&
        tipo !== undefined
      ) {
        if (tipo == "FIXO" && tipo) {
          totalCalc = totalOr + multa;
        } else if (tipo == "PORCENTAGEM" && multa > 0 && tipo) {
          totalCalc = totalOr + (totalOr * multa) / 100;
        }
      } else {
        totalCalc = totalOr;
      }

      //  aplica juros de atraso, se houver
      const dataChecada = moment(hoje).add(1, "days");
      const mesesAtraso = vencimentoMomentPagar.isValid()
        ? moment(dataChecada).diff(vencimentoMomentPagar, "months", true)
        : 0;

      if (
        jurosNum > 0 &&
        vencimentoMomentPagar.isValid() &&
        moment(dataChecada).isAfter(vencimentoMomentPagar)
      ) {
        const juroMes = jurosNum * Math.floor(mesesAtraso);
        totalCalc = totalCalc + (totalCalc * juroMes) / 100;
      }

      totalCalc = totalCalc - valorPago;


      cadastroCopy.total = totalCalc.toFixed(2);

      return {
        ...state,
        contaPagar: action.payload,
        cadastro: cadastroCopy,
        cifrao: copyCifrao,
      };
    }
    case "CONTAS_PAGAR_MUDAR_TIPO": {
      const copyContas = { ...state.cadastro };
      let copyCifrao = { ...state.cifrao };

      if (copyContas.multaTipo?.value == "FIXO") {
        copyCifrao = "R$";
      } else {
        copyCifrao = "%";
      }

      return { ...state, cifrao: copyCifrao };
    }
    case "CONTA_PAGAR_ACAO":
      return { ...state, acao: action.payload };
    case "CONTAS_PAGAR_PAGINATION":
      return { ...state, paginationPagar: action.payload };
    case "CONTAS_PAGAR_CHANGE_VALOR": {
      const copyContas = { ...state.cadastro };

      if (action.input == "valor") {
        if (isNaN(action.payload)) {
          copyContas["valor"] = Number(action.payload.replace(",", "."));
        } else {
          copyContas["valor"] = Number(action.payload);
        }
      } else {
        copyContas[action.input] = action.payload;
      }

      return { ...state, cadastro: copyContas };
    }
    case "CONTAS_CALCULAR_DESCONTO": {
      const copy = { ...state.cadastro };

      // datas
      const hoje = moment().startOf("day");
      const dataChecada = hoje.clone().add(1, "day"); // carência de 1 dia
      const vencimento = moment(copy.vencimento).startOf("day");

      // 1) converte inputs em número
      const valorOrig = Number(copy.valor);      // valor original da fatura
      const descontoNum = Number(copy.desconto);   // desconto aplicado
      const acrescimoNum = Number(copy.acrescimo); // acréscimo aplicado
      const valorPagoNum = Number(copy.valorPago);  // já pago
      const multaNum = Number(copy.multa);      // multa fixa ou % da multa
      const jurosNum = Number(copy.juros);      // taxa mensal de juros em %
      const tipo = copy.multaTipo?.value;        // "FIXO" ou "PORCENTAGEM"

      // 2) recalcula o saldo (sem juros nem multa)
      copy.saldo = valorOrig - descontoNum + acrescimoNum - valorPagoNum;

      // 3) calcula o total com multa e juros sobre o valor original
      let totalCalc = valorOrig + acrescimoNum;

      if (dataChecada.isAfter(vencimento)) {
        // 3a) aplica multa
        if (tipo === "FIXO") {
          totalCalc += multaNum;
        } else if (tipo === "PORCENTAGEM" && multaNum > 0) {
          totalCalc += (valorOrig * multaNum) / 100;
        }

        // 3b) aplica juros mensais
        if (jurosNum > 0) {
          const mesesAtraso = Math.floor(
            dataChecada.diff(vencimento, "months", true)
          );
          totalCalc += (valorOrig * jurosNum * mesesAtraso) / 100;
        }
      }

      // 4) subtrai desconto e o que já foi pago
      totalCalc = totalCalc - descontoNum - valorPagoNum;

      // 5) formata o resultado
      copy.total = totalCalc.toFixed(2);

      return {
        ...state,
        cadastro: copy
      };
    }


    case "CONTAS_CALCULAR_TOTAL": {
      const copy = { ...state.cadastro };
      const hoje = new Date();


      const saldoNum = Number(copy.saldo);
      const multaNum = Number(copy.multa);
      const tipo = copy.multaTipo?.value;


      let total = saldoNum;

      if (moment(hoje).isAfter(moment(copy.vencimento))) {
        if (tipo === "FIXO") {
          total = saldoNum + multaNum;
        } else if (tipo === "PORCENTAGEM" && multaNum > 0) {
          total = saldoNum + (saldoNum * multaNum) / 100;
        }
      }

      copy.total = total.toFixed(2);


      return { ...state, cadastro: copyContas };
    }

    case "CONTAS_PAGAR_INPUT_CHANGE": {
      const cadastroCopy = { ...state.cadastro };

      if (
        action.campo == "valor" ||
        action.campo == "desconto" ||
        action.campo == "acrescimo" ||
        action.campo == "valorPago" ||
        action.campo == "saldo" ||
        action.campo == "multa" ||
        action.campo == "juros"
      ) {
        cadastroCopy[action.campo] = parseValorBr(action.payload);
      } else {
        cadastroCopy[action.campo] = action.payload;
      }

      if (action.campo === "categoria") {
        const v = action.payload?.value;
        cadastroCopy.categoria_id =
          v != null && v !== "" ? Number(v) : null;
      }

      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_PAGAR_DESCONTO": {
      const copy = { ...state.cadastro };
      const hoje = new Date();

      const somaPagamentos = somaPagamentosEmbarque(copy.pagamentosEmbarque);
      let valorNum = parseValorBr(copy.valor);
      const descontoNum = parseValorBr(copy.desconto);
      const acrescimoNum = parseValorBr(copy.acrescimo);
      const valorPagoNum =
        (copy.pagamentosEmbarque || []).length > 0
          ? somaPagamentos
          : parseValorBr(copy.valorPago);

      if (valorNum <= 0 && somaPagamentos > 0) {
        valorNum = somaPagamentos;
      }

      const jurosNum = parseValorBr(copy.juros);
      const multaNum = parseValorBr(copy.multa);

      copy.saldo = valorNum - descontoNum + acrescimoNum - valorPagoNum;

      let total = copy.saldo;
      const tipo = copy.multaTipo?.value;

      if (moment(hoje).isAfter(moment(copy.vencimento))) {
        if (tipo === "FIXO") {
          total = copy.saldo + multaNum;
        } else if (tipo === "PORCENTAGEM" && multaNum > 0) {
          total = copy.saldo + (copy.saldo * multaNum) / 100;
        }
      }

      const dataChecada = moment(hoje).add(1, "days");
      const mesesAtraso = moment(dataChecada).diff(
        moment(copy.vencimento),
        "months",
        true
      );
      if (jurosNum > 0 && moment(dataChecada).isAfter(moment(copy.vencimento))) {
        const juroMes = jurosNum * Math.floor(mesesAtraso);
        total = total + (total * juroMes) / 100;
      }

      copy.total = total.toFixed(2);

      return { ...state, cadastro: copy };
    }

    case "CONTAS_PAGAR_PAGAMENTO_EMBARQUE_ADD": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      arr.push(linhaPagamentoEmbarqueVazia());
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_PAGAR_PAGAMENTO_EMBARQUE_REMOVE": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr.length <= 1) return state;
      arr.splice(action.index, 1);
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_PAGAR_PAGAMENTO_EMBARQUE_CHANGE_FORMA": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], formaPagamento: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_PAGAR_PAGAMENTO_EMBARQUE_CHANGE_VALOR": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], valor: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_PAGAR_PAGAMENTO_EMBARQUE_CHANGE_CAMPO": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], [action.campo]: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_PAGAR_PAGAMENTO_EMBARQUE_CHANGE_PARCELA": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], parcela: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_PAGAR_PAGAMENTO_EMBARQUE_CHANGE_BANCO": {
      const cadastroCopy = { ...state.cadastro };
      const arr = [...(cadastroCopy.pagamentosEmbarque || [])];
      if (arr[action.index] == null) return state;
      arr[action.index] = { ...arr[action.index], banco: action.payload };
      cadastroCopy.pagamentosEmbarque = arr;
      return { ...state, cadastro: cadastroCopy };
    }

    case "CONTAS_PAGAR_CATEGORIA_FETCH": {
      return { ...state, categorias: action.payload };
    }
    case "CONTAS_PAGAR_CATEGORIA_INPUT_CHANGE": {
      let categgoriaCopy = { ...state.categoriaCadastrar };

      if (action.campo == "limpar") {
        categgoriaCopy = {};
      } else {
        categgoriaCopy[action.campo] = action.payload;
      }
      return { ...state, categoriaCadastrar: categgoriaCopy };
    }

    case "CONTAS_PAGAR_SUBCATEGORIA_FETCH": {
      return { ...state, subCategorias: action.payload };
    }

    case "CONTAS_PAGAR_SUBCATEGORIA_INPUT_CHANGE": {
      let categgoriaCopy = { ...state.subCategoriaCadastrar };

      if (action.campo == "limpar") {
        categgoriaCopy = {};
      } else {
        categgoriaCopy[action.campo] = action.payload;
      }

      return { ...state, subCategoriaCadastrar: categgoriaCopy };
    }

    case "CONTAS_PAGAR_CHECK": {
      const contaCopy = [...state.contasPagar];
      contaCopy[action.index].selecionado = action.value;

      return { ...state, contasPagar: contaCopy };
    }

    case "CONTAS_PAGAR_CATEGORIA_ABRIR_GRUPO": {
      const categoriasCopy = [...state.categorias];
      const index = action.index;
      const teste = { ...categoriasCopy[index] };

      teste.grupoAberto = !teste.grupoAberto;
      categoriasCopy[index] = teste;

      return { ...state, categorias: categoriasCopy };
    }

    case "CONTAS_PAGAR_SET_FILTRO": {
      const dadosFiltroCopy = { ...state.dadosFiltro };
      dadosFiltroCopy[action.campo] = action.valor;
      return { ...state, dadosFiltro: dadosFiltroCopy };
    }
    
    case "CONTAS_PAGAR_SET_FILTRO_CLEAR": {
      const dadosFiltroCopy = {
        id: "",
        origem: "",
        nome: "",
        categoria: "",
        subCategoria: "",
        status: [],
        tipoConta: "",
        segmento: "",
        clear: false,
        ...datasFiltroMesCorrente(),
      };
      return { ...state, dadosFiltro: dadosFiltroCopy };
    }

    case "CONTA_PAGAR_LIMPAR_INPUTS": {
      return {
        ...state,
        cadastro: cloneDeep(INITIAL_STATE.cadastro),
        // categorias: [],
        // subCategorias: [],

      };
    }

    default:
      return state;
  }
};
